export class MemberConstants {
  public static romaniaId = 256;
}
